import { Box } from "@mui/material";
import { VideoPlayer } from "../VideoPlayer/VideoPlayer";
import { BackgroundMediaRoot } from "./BackgroundMedia.styles";
import { useRouteParams } from "../../context/RouteParamsContext";
import bgImg from "../../assets/background/nasa_plane.jpg";

export const BackgroundMedia = () => {
  const { projectName } = useRouteParams();

  const media = {
    electra: {
      poster:
        "https://cdn.prod.website-files.com/663dbdc0a9d2236489a45ce8%2F672ff98cb3d89a8fccfd6376_01-plane-poster-00001.jpg",
      sources: [
        {
          url: "https://cdn.prod.website-files.com/663dbdc0a9d2236489a45ce8%2F672ff98cb3d89a8fccfd6376_01-plane-transcode.mp4",
          type: "video/mp4",
        },
        {
          url: "https://cdn.prod.website-files.com/663dbdc0a9d2236489a45ce8%2F672ff98cb3d89a8fccfd6376_01-plane-transcode.webm",
          type: "video/webm",
        },
      ],
    },
    airbus: {
      poster:
        "https://mediaassets.airbus.com/medias/domain38/media3266/502603-q9t91u26ki-whr.jpg",
      sources: [
        {
          url: "https://mediaassets.airbus.com/medias/domain38/media3266/502603-q9t91u26ki-1080.mp4",
          type: "video/mp4",
        },
        {
          url: "https://mediaassets.airbus.com/medias/domain38/media3266/502603-q9t91u26ki-1080.mp4",
          type: "video/webm",
        },
      ],
    },
  };

  const selectedMedia = media[projectName];

  return (
    <BackgroundMediaRoot>
      {selectedMedia ? (
        <VideoPlayer
          poster={selectedMedia.poster}
          sources={selectedMedia.sources}
        />
      ) : (
        <Box
          component="img"
          src={bgImg}
          alt="Fallback"
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      )}
    </BackgroundMediaRoot>
  );
};

BackgroundMedia.defaultProps = {
  timeValue: 0,
  action: { descriptor: {} },
  onSlidePause: () => {},
};
